import { FC, useEffect, useState } from 'react';
import CreateEditLayout from '@features/workspace/components/layouts/sub/create-edit-layout';
import history from '@app/services/history';
import LeaveFormSaveDialog from '@features/workspace/components/dialogs/leave-form-save-dialog';
import { useAppDispatch } from '@store/hooks';
import { setIsLoading } from '@store/features/loading';
import NoteForm, {
  INIT_DATA,
} from '@features/workspace/views/company/notes/form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import noteSchema from '@features/workspace/schemas/note-schema';
import logger from '@app/services/logger';

const NoteCreate: FC<any> = () => {
  const dispatch = useAppDispatch();
  const backUri = '/customer/contact#notes';

  const [data, setData] = useState(INIT_DATA);
  const [initData, setInitData] = useState(INIT_DATA);

  const [openLeaveFormSaveDialog, setOpenLeaveFormSaveDialog] = useState(false);

  const { register, handleSubmit, formState, reset, control } = useForm({
    defaultValues: initData,
    resolver: yupResolver(noteSchema),
  });

  const { errors, isDirty } = formState;

  useEffect(() => {
    const initialState = {
      ...INIT_DATA,
    };

    setInitData(initialState);
    setData(initialState);
    logger.debug('Init state', initialState);
    reset(initialState);
  }, []);

  const onSave = async () => {
    dispatch(setIsLoading(true));

    // TODO: save note integration

    dispatch(setIsLoading(false));
  };

  const goBack = () => {
    history.push(backUri);
  };

  const onGoBack = () => {
    if (isDirty) {
      setOpenLeaveFormSaveDialog(true);
    } else {
      goBack();
    }
  };

  return (
    <CreateEditLayout
      backUri={backUri}
      onBack={onGoBack}
      onCancel={onGoBack}
      onSave={onSave}
    >
      <NoteForm
        control={control}
        data={data}
        errors={errors}
        register={register}
      />
      <LeaveFormSaveDialog
        open={openLeaveFormSaveDialog}
        onAccept={handleSubmit(onSave)}
        onClose={() => setOpenLeaveFormSaveDialog(false)}
        onReject={goBack}
      />
    </CreateEditLayout>
  );
};

export default NoteCreate;
